import React from 'react';
import FlowEditor from './FlowChartComponent';
import idFlow from '../Settings/Options';

/**
 * @type {React.FC}
 */
const App = () => {
  return (
    <div className="App">
      <header className="App-header">
        <h1><center>Diagrama de Flujo Flowise - {idFlow}</center></h1>
      </header>
      <main>
        <FlowEditor />
      </main>
    </div>
  );
}

export default App;
